import {NavigablePage} from '../../interfaces/navigation/navigable-page.interface';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';
import {NavigableComponent} from '../../interfaces/navigation/navigable-component.interface';
import {StreamingServicesUtil} from '../../utils/streaming-services.util';

const HeroBanner: NavigableComponent = {
  componentId: 'hero-banner',
  shouldShowComponent: false,
  process: ((stateService: TvShopStateService) => {
    return stateService.selectSnapshot(state => !state.customer.isEligibleForStreamingBundles);
  })
};

const HeroStreamingBundleCarousel: NavigableComponent = {
  componentId: 'hero-streaming-bundle-carousel',
  shouldShowComponent: false,
  process: ((stateService: TvShopStateService) => {
    return stateService.selectSnapshot(state => state.customer.isEligibleForStreamingBundles);
  })
};

const StandaloneStreamingCarousel: NavigableComponent = {
  componentId: 'standalone-streaming-carousel',
  shouldShowComponent: false,
  process: ((stateService: TvShopStateService) => {
    const streamingServices = stateService.selectSnapshot(state => state.tvShopStreamingServices);
    const standaloneStreamingServicesInCarousel = StreamingServicesUtil.getStandAloneStreamingServices(streamingServices);
    const showCard = stateService.selectSnapshot(state => state.customer.isEligibleForStreamingBundles);
    const isSoho = stateService.selectSnapshot(state => state.customer.isSohoCustomer);
    return showCard && standaloneStreamingServicesInCarousel.length > 0 && !isSoho;
  })
};

const ProductCarousel: NavigableComponent = {
  componentId: 'product-carousel',
  shouldShowComponent: false,
  process: ((stateService: TvShopStateService) => {
    const packs = stateService.selectSnapshot(state => state.tvShopEntertainmentPacks);
    return packs.length > 0;
  })
};

export const NavigableComponentConfigurationHomePage: NavigablePage = {
  title: 'Shop',
  navigableComponents: [
    HeroBanner,
    HeroStreamingBundleCarousel,
    ProductCarousel,
    StandaloneStreamingCarousel
  ]
};
